import { useDispatch } from 'react-redux'
/* eslint-disable react/jsx-no-duplicate-props */

/* eslint-disable max-len */
import React, {useContext} from 'react'
import AnimatedList from '../../../components/Animation/AnimatedList'
import { useSelector } from 'react-redux'
import { convertEpochToDateFormat } from '../../../CommonMethods/convertEpochToDateFormat'
import { useNavigate } from 'react-router-dom'
import { useSearchParams } from 'react-router-dom'
import { resetAlertNotificationSearch } from '../../../redux/alerAndNotificationSearchSlice'
import GlobalContext from '../../../components/Context/GloablContext'
import { organizationusersList } from '../../../slices/apiSlice'

const TableBodyAlerts = ({ tableData,fromPatientTab,
    indexNum,
    handleAcknowlegde,}) => {
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [searchParams,setSearchParams]=useSearchParams({})
    const navigate=useNavigate()
    const dispatch=useDispatch()
    const {setIsSearchOpen, isSearchOpen} = useContext(GlobalContext);

    
    // handle the username if last name is not there only show first name
    // Check if sender_last_name is not empty or not just spaces
    const hasLastName = tableData?.sender_last_name && tableData?.sender_last_name.trim() !== "";

    // Construct the sender's full name conditionally
    const senderFullName = hasLastName
        ? `${tableData?.sender_first_name || ''} ${tableData?.sender_last_name || ''}`
        : tableData?.sender_first_name;

    const date = convertEpochToDateFormat(tableData?.created_at, dateformat)
   
    return (
        <>
            <AnimatedList
                id={tableData.patient_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                cursorpointer
                handleClick={(e)=>{
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        setIsSearchOpen(false)
                        dispatch(resetAlertNotificationSearch())
                        dispatch(organizationusersList.util.resetApiState())
                        fromPatientTab==='true'?navigate(`/alerts-notifications/provider-list/${tableData?.patient_object_id}/${tableData?.patient_id}`,{state:{...Object.fromEntries(searchParams),'user_id':tableData?.patient_id,'id':tableData?._id}}):navigate(`/manage-dashboard/provider-list/${tableData._id}/${tableData.patient_id}`,{state:{...Object.fromEntries(searchParams),'user_id':tableData?.patient_id,'id':tableData?._id}})
                    }
                }}

                child={
                    <>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{date}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.patient_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{[tableData?.patient_first_name, tableData?.patient_middle_name, tableData?.patient_last_name].filter(Boolean).join(' ')}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.age===''|| tableData?.age===undefined || tableData?.age=== null)? '-' : tableData?.age}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.gender}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.alert_priority}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.alert_title}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {tableData?.alert_message === "" || tableData?.alert_message === undefined
                                ? "-"
                                : tableData?.alert_message.length > 87
                                    ? `${tableData.alert_message.slice(0, 87)}...`
                                    : tableData.alert_message}
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.sender_user_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{senderFullName}</td>
                        <td className={`px-[18px] py-2 sticky prevent-click last-td prevent-click ${selectedRows.map((item) => item.id).includes(tableData?.patient_id) ? 'bg-[#F8EEF1]' : 'bg-white '} right-[100px]`}>
                            <div className="flex items-center justify-start prevent-click">
                                <span  id={`acknowledge-${indexNum}`}
                                    className={tableData?.status !== "Pending" ? "py-1 px-4 rounded-[6px] disabled cursor-default text-sm leading-normal font-semibold text-[#52555D] bg-[#E7EAF4] prevent-click" : "py-1 px-4 rounded-[6px] disabled border border-[#972E4C] text-sm leading-normal font-semibold text-[#972E4C] prevent-click"}
                                    onClick={tableData?.status === "Pending" ? () => handleAcknowlegde(tableData) : undefined}
                                >{tableData?.status === "Pending" ? "Acknowledge" : "Acknowledged"}</span>
                            </div>
                        </td>
                        <td className={`px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] sticky right-[-1px] rounded-br-[2px] prevent-click ${selectedRows.map((item) => item.id).includes(tableData?.patient_id) ? 'bg-[#F8EEF1]' : 'bg-white '} last-td`}>
                            <button
                                id="View"
                                // No onClick of its own: the click bubbles to the row's handleClick, which navigates.
                                // Navigating here as well pushed the details page twice, so Back needed two presses.
                                className="py-1 px-4 rounded-[6px] disabled border border-[#972E4C] text-sm leading-normal font-semibold text-[#972E4C] "
                            >View</button>
                          
                        </td>
                    </>
                } 
            />
        </>
    )
}

export default TableBodyAlerts
